module.exports = function getResource(label, vars = []) {
    const resources = {
        unverifiedTitle: 'Please double-check your address',
        unverifiedLegend: 'Your shipping address could not be verified.',
        unverifiedButtonText: 'Edit address',
        recommendedTitle: 'Recommended Address',
        recommendedButtonText: 'Use Recommended',
        unverifiedTitleR3: 'Please Verify Address',
        unverifiedLegendR3: 'Your address could not be verified.',
        unverifiedButtonTextR3: 'Edit Address'
    };

    return resources[label];
};
